export default __webpack_public_path__ + "static/media/KEO cyprus.811b9fbe.png";